import type { ReactNode } from 'react';
import { CNButton } from '@zawarski/eti-ui';

/** The MUI Fab's resting shadow (elevation 6), kept so the button still floats over the lists. */
const FAB_SHADOW =
  '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)';

/**
 * The floating action button in the REP primary blue, on eti-ui's CNButton: a 40px pill with an
 * uppercase label and a trailing icon ("NEW EXERCISE ⊕"). Every page uses the pill, so there is
 * no round icon-only variant. It sits `bottom`/`right` px from the corner of the nearest
 * positioned ancestor.
 */
const Fab = ({
  onClick,
  ariaLabel,
  children,
  bottom,
  right = 24,
}: {
  onClick: () => void;
  ariaLabel: string;
  children: ReactNode;
  bottom: number;
  right?: number;
}) => (
  <CNButton
    type='button'
    aria-label={ariaLabel}
    className='palmetto-print-hide rep:absolute rep:z-1001 rep:h-10! rep:rounded-full! rep:bg-[#2961FD]! rep:px-4! rep:text-sm! rep:font-medium! rep:text-white! rep:uppercase rep:hover:bg-[#1C43B1]! rep:[&_svg:not([class*=size-])]:size-6!'
    style={{ bottom, right, boxShadow: FAB_SHADOW }}
    onClick={onClick}>
    {children}
  </CNButton>
);

export default Fab;
